import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ResponsiveDialog from '../dialog/dialog';
import SimpleBackdrop from '../loading/loading';
import authService from '../../service/auth/authService';

const theme = createTheme();

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [open, setOpen] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [messageDialog, setMessageDialog] = useState('');
    const [titleDialog, setTitleDialog] = useState('');
    const [statusDialog, setStatusDialog] = useState('');

    const navigate = useNavigate();

    const sendEmail = async () => {
        if (!email) {
            handleDialogOpen();
            setTitleDialog('Campo obrigatório');
            setMessageDialog('Por favor, informe seu email.');
            setStatusDialog('warning');
            return;
        }

        // Validação básica de email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            handleDialogOpen();
            setTitleDialog('Email inválido');
            setMessageDialog('Por favor, informe um email válido.');
            setStatusDialog('warning');
            return;
        }

        setOpen(true);

        try {
            const response = await authService.forgotPassword(email);
            
            setOpen(false);
            
            if (response.success) {
                handleDialogOpen();
                setTitleDialog('Email enviado');
                setMessageDialog(response.message || 'Um link de redefinição de senha foi enviado para seu email.');
                setStatusDialog('success');
                
                // Opcional: redirecionar após alguns segundos
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            } else {
                handleDialogOpen();
                setTitleDialog('Erro ao enviar email');
                setMessageDialog(response.message || 'Erro ao enviar email de recuperação de senha.');
                setStatusDialog('error');
            }
        } catch (error) {
            console.error('Erro ao enviar email:', error);
            setOpen(false);
            handleDialogOpen();
            setTitleDialog('Erro ao enviar email');
            
            if (error.message && error.message !== 'Ocorreu um erro inesperado. Tente novamente.') {
                setMessageDialog(error.message);
            } else if (error.status === 404 || error.response?.status === 404) {
                setMessageDialog('Email não encontrado no sistema.');
            } else if (error.status === 500 || error.response?.status === 500) {
                setMessageDialog('Erro interno do servidor. Tente novamente.');
            } else {
                setMessageDialog('Erro ao conectar com o servidor. Verifique sua conexão.');
            }
            
            setStatusDialog('error');
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDialogOpen = () => {
        setOpenDialog(true);
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
    };

    return (
        <ThemeProvider theme={theme}>
            <Container component="main" style={{ padding: 60, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
                <SimpleBackdrop
                    open={open}
                    handleClose={handleClose}
                    title="Enviando email..."
                />

                <ResponsiveDialog
                    open={openDialog}
                    handleClose={handleDialogClose}
                    title={titleDialog}
                    message={messageDialog}
                    status={statusDialog}
                />

                <Card
                    sx={{
                        maxWidth: 500,
                        width: '100%',
                        boxShadow: '0 0 60px rgba(0, 0, 0, 0.1)',
                        borderRadius: '14px',
                    }}
                >
                    <CardContent sx={{ padding: 4 }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <Typography component="h1" variant="h5" sx={{ marginBottom: 2, fontWeight: 'bold' }}>
                                Esqueci minha senha
                            </Typography>
                            
                            <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 3, textAlign: 'center' }}>
                                Digite seu email abaixo e enviaremos um link para redefinir sua senha.
                            </Typography>

                            <Box sx={{ width: '100%' }}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="email"
                                    label="Email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    autoFocus
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            sendEmail();
                                        }
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '10px',
                                        },
                                    }}
                                />

                                <Button
                                    type="button"
                                    fullWidth
                                    variant="contained"
                                    onClick={sendEmail}
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        backgroundColor: 'red',
                                        color: 'white',
                                        padding: '10px',
                                        borderRadius: '10px',
                                        '&:hover': {
                                            backgroundColor: '#d32f2f',
                                        },
                                    }}
                                >
                                    Enviar link de redefinição
                                </Button>

                                <Box sx={{ textAlign: 'center', mt: 2 }}>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        fullWidth
                                        onClick={() => navigate('/login')}
                                        sx={{
                                            borderRadius: '10px',
                                            textTransform: 'none',
                                        }}
                                    >
                                        Voltar para o login
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Container>
        </ThemeProvider>
    );
}